const medicalRecord = {
  namespaced: true,
  state: {
    // 実施時期
    doctorName: '',
    implementationDate: '',
    startTime: '',
    endTime: '',
    // 患者情報
    mainSymptom: '',
    // 診察
    cough: '',
    shortnessOfBreath: '',
    pharyngitis: '',
    senseOfFatigue: '',
    gastrointestinal: '',
    dehydration: '',
    // アセスメント
    diagnostic: '',
    diagnosticOther: '',
    finding: '',
    // プラン
    plan: '',
    planOther: '',
    prescription: '',
    // 事前問診登録済判定
    registeredInterview: false
  },
  getters: {
    doctorName: state => state.doctorName,
    implementationDate: state => state.implementationDate,
    startTime: state => state.startTime,
    endTime: state => state.endTime,
    mainSymptom: state => state.mainSymptom,
    cough: state => state.cough,
    shortnessOfBreath: state =>state.shortnessOfBreath,
    pharyngitis: state => state.pharyngitis,
    senseOfFatigue: state => state.senseOfFatigue,
    gastrointestinal: state => state.gastrointestinal,
    dehydration: state => state.dehydration,
    diagnostic: state => state.diagnostic,
    diagnosticOther: state => state.diagnosticOther,
    finding: state => state.finding,
    plan: state => state.plan,
    planOther: state => state.planOther,
    prescription: state => state.prescription,
    registeredInterview: state => state.registeredInterview
  },
  mutations: {
    setDoctorName: (state, payload) => state.doctorName = payload,
    setImplementationDate: (state, payload) => state.implementationDate = payload,
    setStartTime: (state, payload) => state.startTime = payload,
    setEndTime: (state, payload) => state.endTime = payload,
    setMainSymptom: (state, payload) => state.mainSymptom = payload,

    setCough: (state, payload) => state.cough = payload,
    setShortnessOfBreath: (state, payload) => state.shortnessOfBreath = payload,
    setPharyngitis: (state, payload) => state.pharyngitis = payload,
    setSenseOfFatigue: (state, payload) => state.senseOfFatigue = payload,
    setGastrointestinal: (state, payload) => state.gastrointestinal = payload,
    setDehydration: (state, payload) => state.dehydration = payload,

    setDiagnostic: (state, payload) => state.diagnostic = payload,
    setDiagnosticOther: (state, payload) => state.diagnosticOther = payload,
    setFinding: (state, payload) => state.finding = payload,

    setPlan: (state, payload) => state.plan = payload,
    setPrescription: (state, payload) => state.prescription = payload,
    setPlanOther: (state, payload) => state.planOther = payload,
    setRegisteredInterview: (state, payload) => state.registeredInterview = payload,

    setRecordTime: (state, payload) => {
      state.doctorName = payload.doctorName
      state.implementationDate = payload.implementationDate
      state.startTime = payload.startTime
      state.endTime   = payload.endTime
    },
    setConsultation: (state, payload) => {
      state.cough = payload.cough
      state.shortnessOfBreath = payload.shortnessOfBreath
      state.pharyngitis  = payload.pharyngitis
      state.senseOfFatigue = payload.senseOfFatigue
      state.gastrointestinal = payload.gastrointestinal
      state.dehydration = payload.dehydration
    },
    setAssessment: (state, payload) => {
      state.diagnostic = payload.diagnostic
      state.diagnosticOther = payload.diagnosticOther
      state.finding    = payload.finding
    },
    setPlanData: (state, payload) => {
      state.plan = payload.plan
      state.prescription = payload.prescription
      state.planOther = payload.planOther
    }
  },
  actions: {
    setDoctorName: ({ commit }, value) => commit('setDoctorName', value),
    setImplementationDate: ({ commit }, value) => commit('setImplementationDate', value),
    setStartTime: ({ commit }, value) => commit('setStartTime', value),
    setEndTime: ({ commit }, value) => commit('setEndTime', value),
    setMainSymptom: ({ commit }, value) => commit('setMainSymptom', value),

    setCough: ({ commit }, value) => commit('setCough', value),
    setShortnessOfBreath: ({ commit }, value) => commit('setShortnessOfBreath', value),
    setPharyngitis: ({ commit }, value) => commit('setPharyngitis', value),
    setSenseOfFatigue: ({ commit }, value) => commit('setSenseOfFatigue', value),
    setGastrointestinal: ({ commit }, value) => commit('setGastrointestinal', value),
    setDehydration: ({ commit }, value) => commit('setDehydration', value),

    setDiagnostic: ({ commit }, value) => commit('setDiagnostic', value),
    setDiagnosticOther: ({ commit }, value) => commit('setDiagnosticOther', value),
    setFinding: ({ commit }, value) => commit('setFinding', value),

    setPlan: ({ commit }, value) => commit('setPlan', value),
    setPrescription: ({ commit }, value) => commit('setPrescription', value),
    setPlanOther: ({ commit }, value) => commit('setPlanOther', value),

    setRegisteredInterview: ({ commit }, value) => commit('setRegisteredInterview', value)
  }
};

export default medicalRecord;
